import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios, { AxiosError } from 'axios';
import {
  IDownloadFile,
  IValidationErrors,
  IDownloadStateError
} from '../../models/downloadFile';
import { config } from '../../../config';

import { RootState } from '../../../store';
import { ResponseType } from 'axios';
import { checkIfStatusIsForbidden } from '../auth/authRedirect';

const saveFile = (fileName: string, data: any) => {
  const blob = new Blob([data]);
  const createUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.download = fileName;
  link.href = createUrl;
  link.click();
};

export const authClient = (getState) =>
  axios.create({
    baseURL: `${config.DR_HERANCA_API}/api/`,
    responseType: 'json',
    headers: {
      Authorization: `Bearer ${(getState() as RootState).auth.token}`
    }
  });

export const fetchDownloadFile = createAsyncThunk(
  'download/file',
  async (parameters: IDownloadFile, { rejectWithValue, getState }) => {
    try {
      const axiosResponseType: ResponseType = 'blob';
      const response = await authClient(getState).get(
        `${parameters.endpoint}`,
        { responseType: axiosResponseType }
      );
      saveFile(parameters.fileName, response.data);
    } catch (err) {
      let error: AxiosError<IValidationErrors> = err;
      if (!error.response) {
        throw err;
      } else if (error.response) {
        checkIfStatusIsForbidden(error.response);
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const initialState = {
  error: null
} as IDownloadStateError;

const downloadFileSlice = createSlice({
  name: 'download_file',
  initialState,
  reducers: {}
});

export default downloadFileSlice.reducer;
